var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav tab-filter-menu d-flex align-items-center"},_vm._l((_vm.filters),function(ref){
var id = ref.id;
var value = ref.value;
return _c('li',{staticClass:"nav-item",on:{"click":function($event){return _vm.filterValue(id)}}},[_c('a',{class:("nav-link py-0 " + (_vm.showActive && _vm.filter === id ? 'active' : '')),attrs:{"href":"#"}},[_vm._v("\n            "+_vm._s(value)+"\n        ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }